import WithScopes from "components/common/WithScopes";
import { SCOPES } from "enums/scopes.enum";
import ProtectedLayout from "layouts/common/general/ProtectedLayout";
import ScheduleMonitorLayout from "layouts/app-taxi-ranking/schedule-monitor";
import NotFound from "pages/common/errors/not-found/NotFound";
import ScheduleMonitorPage from "./schedule-monitor/schedule-monitor-page";

const root = {
    path: "admin/schedules/health",
    element: (
        <ProtectedLayout>
            <ScheduleMonitorLayout />
        </ProtectedLayout>
    ),
    children: [
        {
            path: "",
            element: (
                <WithScopes filterScopes={[SCOPES.VIEW_SCHEDULE_MONITOR_PAGE]} isFullScreen>
                    <ScheduleMonitorPage />
                </WithScopes>
            ),
        },
        {
            path: "page-not-found",
            element: <NotFound />,
        },
    ],
};

export default root;
